export default __webpack_public_path__ + "static/media/404.a90a92b6.PNG";